import React, { useState } from 'react';
// import Logo from '../Images/Logo SVG/Sumizan Logo SVG.svg';
import '../CSS/Header.css';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="header">
      <div className="brand">
        {
          <Logo />
        }
        {/* <div>
            <img src={Logo} alt="Logo" className="logo" />
            <span className='logo_text'>NExGEN<span className='red logo_text'>TECH</span></span>
            </div> */}
        <button className="hamburger" onClick={toggleMobileMenu}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </button>
      </div>

      {/* Desktop Navigation */}
      <ul className="desktop-nav">
        <li>
          <Link to="/" className="link">Home</Link>
        </li>
        <li>
          <Link to="/about" className="link">About</Link>
        </li>
        <li>
          <Link to="/services" className="link">Services</Link>
        </li>
        <li>
          <Link to="/portfolio" className="link">Portfolio</Link>
        </li>
        <li>
          <Link to="/contact" className="link">Contact</Link>
        </li>
      </ul>

      {/* Mobile Navigation */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'menu-open' : ''}`}>
        <div className='mob_brand'>
            <Logo />
          {/* <div>
            <img src={Logo} alt="Logo" className="logo" />
          </div> */}
          <button className="close-btn" onClick={toggleMobileMenu}>
            &times;
          </button>
        </div>

        <ul>
          <li>
            <Link to="/" className="link" onClick={toggleMobileMenu}>Home</Link>
          </li>
          <li>
            <Link to="/about" className="link" onClick={toggleMobileMenu}>About</Link>
          </li>
          <li>
            <Link to="/services" className="link" onClick={toggleMobileMenu}>Services</Link>
          </li>
          <li>
            <Link to="/portfolio" className="link" onClick={toggleMobileMenu}>Portfolio</Link>
          </li>
          <li>
            <Link to="/contact" className="link" onClick={toggleMobileMenu}>Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;


// import React from 'react';
// import Logo from '../Images/Logo SVG/Sumizan Logo SVG.svg'
// import '../CSS/Main.css'
// import '../CSS/Common.css';
// import '../CSS/Header.css';
// import { Link } from 'react-router-dom';

// const Header = () => {
//   return (
//     <React.Fragment>
//       <nav className='header'>
//         <div className='brand'>
//           <img src={Logo} alt='logo' className='logo' />
//         </div>
//         <ul className='headLinks'>
//         <li>
//             <Link to='/' style={{ textDecoration: 'none'}} className='link'>
//               Home
//             </Link>
//           </li>
//           <li>
//             <Link to='/about' style={{ textDecoration: 'none'}} className='link'>
//               About
//             </Link>
//           </li>
//           <li>
//             <Link to='/services' style={{ textDecoration: 'none'}} className='link'>
//               Services
//             </Link>
//           </li>
//           <li>
//             <Link to='/portfolio' style={{ textDecoration: 'none'}} className='link'>
//               Portfolio
//             </Link>
//           </li>
//           <li>
//             <Link to='/contact' style={{ textDecoration: 'none'}} className='link'>
//               Contact
//             </Link>
//           </li>
//         </ul>
//       </nav>
//     </React.Fragment>
//      );
//     };
    
//     export default Header;